import { useEffect, useRef } from 'react';

const useRequestAnimationFrame = (callback: () => any, deps: any[] = []) => {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    let reqId = -1;

    const loop = () => {
      callbackRef.current();

      reqId = requestAnimationFrame(loop);
    };

    loop();

    return () => cancelAnimationFrame(reqId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps ?? []);
};

export default useRequestAnimationFrame;
